export enum EStrategyPortfolioDocumentType {
    DemolitionPlan = 1,
    OperatingMethod = 2,
    AerolicsResult = 3,
    ContainmentPlan = 4,
    SiteInstallationPlan = 5,
    AsbestosTechFileAndMPCADegradation = 6,
    PreSalesFileAndMPCADegradation = 7,
    PreDemolitionDiagnostics = 8,
    PreWorkDiagnostics = 9,
    OperatingModeValidationTestResults = 10,
    PreviousStrategy = 11,
    TestSiteResults = 12,
    TestSiteFinalReport = 13,
    ActivitiesInConcernedAndAdjancentRooms = 14,
    BuildingMapWithMPCAIndication = 15,
    PreventionPlan = 16,
    TopographicMap = 17,
    WindRose = 18,
    BuildingPictures = 19,
    BuildingHeightAndPositionOnPlan = 20,
    LaborLawStrategyRequestTSEFO23354 = 21,
    PublicHealthStrategyRequestTSEFO23360 = 22,
    TSEFO58603 = 23,
    TSEFO58536 = 24,
    ProcessSheet = 25,
    Avenant = 26,
    InvestigationPerimeter = 27,
    PDREDematamiante = 28,
    PDRECustom = 29
}
